/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListAssetsOptions,
  ListAssetsStatus200,
  ListAssetsStatus400,
  ListAssetsStatus500,
} from '../types/ListAssets'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listAssets } from '../clients/listAssets'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listAssetsQueryKey = ({ query }: Omit<ListAssetsOptions, 'headers'> = {}) =>
  [{ url: '/v1/assets' }, ...(query ? [query] : [])] as const

type ListAssetsQueryKey = ReturnType<typeof listAssetsQueryKey>

export function listAssetsQueryOptions(
  { query }: ListAssetsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listAssetsQueryKey({ query })
  return queryOptions<
    ListAssetsStatus200,
    ResponseErrorConfig<ListAssetsStatus400 | ListAssetsStatus500>,
    ListAssetsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listAssets({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List assets
 * {@link /v1/assets}
 */
export function useListAssets<
  TData = ListAssetsStatus200,
  TQueryData = ListAssetsStatus200,
  TQueryKey extends QueryKey = ListAssetsQueryKey,
>(
  { query }: { query?: ListAssetsOptions['query'] | (() => ListAssetsOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListAssetsStatus200,
        ResponseErrorConfig<ListAssetsStatus400 | ListAssetsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listAssetsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listAssetsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ListAssetsStatus400 | ListAssetsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
